import React, { useState, useEffect } from 'react';
import logo from '../../assets/svg/logo_front.svg';
import iclogout from '../../assets/svg/ic-logout.svg';
import { useStateContext } from '../../context/ContextProvider.jsx';
import bgImg from '../../assets/img/bg-gr.webp';

const ResponsiveAppBar = () => {  
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [activeLink, setActiveLink] = useState(null);
  const [isFixed, setIsFixed] = useState(false);
  const { token } = useStateContext();
  const [lastScrollY, setLastScrollY] = useState(window.scrollY); 

  const logIn = () => {
        token ? window.location.href = '/new-message' : window.location.href = '/login'
  };
  
  const logOut = () => {
    if (token) {
      localStorage.clear();
      window.location.reload()
    } else {
      window.location.href = '/signup'
    }
  };

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  const navItems = [
    { id: 1, link: '#services', text: 'Our Services' },
    { id: 2, link: '#use-cases', text: 'Use cases' },
    // { id: 3, link: '#pricing', text: 'Pricing' },
    { id: 4, link: '#testimonials', text: 'Testimonials' },
    // { id: 5, link: 'https://wa.me/18009809563?text=Hello', text: 'Contact Us', isExternal: true },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsFixed(window.scrollY > 0);

      let currentActiveLink = null;

      // Detect scrolling direction (up or down)
      const currentScrollY = window.scrollY;
      const isScrollingUp = currentScrollY < lastScrollY;
      setLastScrollY(currentScrollY);

      // Check which section is currently in view
      navItems.forEach(({ id, link }) => {
        const section = document.querySelector(link);
        if (section) {
          const rect = section.getBoundingClientRect();

          if (
            rect.top >= 0 &&
            rect.bottom <= window.innerHeight &&
            rect.height > window.innerHeight / 2
          ) {
            currentActiveLink = id;
          } else if (rect.top < window.innerHeight && rect.bottom > 0) {
            currentActiveLink = id;
          }
        }
      });

      if (currentActiveLink !== activeLink) {
        setActiveLink(currentActiveLink);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [activeLink, lastScrollY]);

  const handleLinkClick = (id, event) => {
    setActiveLink(id);
    setIsNavOpen(false);
    event.preventDefault();
    const target = document.querySelector(navItems.find(item => item.id === id).link);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className={ `mx-auto p-4 flex items-start justify-between max-sm:border-b ${isFixed ? 'fixed top-0 left-0 right-0 z-50' : ''}` } style={isFixed ? { backgroundImage: `url(${bgImg})` } : {}}>
      {/* Logo Section */}
      <div className="flex items-end">
        <img src={logo} alt="Logo" className="h-10 w-auto" />
        {/* Desktop Navigation */}
        <nav className="hidden md:flex ml-28 space-x-6">
          {navItems.map(({ id, link, text }) => (
            <a key={id} href={link} onClick={(event) => handleLinkClick(id, event)} className={`w-28 text-center relative ${activeLink === id ? 'text-white' : ''}`}>
              <span className="text-[#B4BCC8] hover:text-white transition-colors duration-300">
                {text}
              </span>
              {activeLink === id && (
                <div className="absolute mt-1 left-0 right-0 bottom-[-10px] flex justify-center">
                  <svg width="103" height="11" viewBox="0 0 103 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 8.99999C18.3333 3.33332 62.8 -4.60001 102 8.99999" stroke="#D87045" strokeWidth="3" />
                  </svg>
                </div>
              )}
            </a>
          )) }
          <a target='_blank' href="https://wa.me/18009809563?text=Talk2Agent" className={'w-28 text-center relative text-white'}>
              <span className="text-[#B4BCC8] hover:text-white transition-colors duration-300">
                Contact Us
              </span>
          </a>
        </nav>
      </div>
      {/* Sign In and Free Trial Buttons */}
      <div className="hidden md:flex items-center space-x-4">
        <button onClick={logIn} className="bg-[#DF8450] text-white hover:bg-[#c96d3b] transition-colors duration-300 rounded-full ps-1 pe-6 py-1 flex items-center space-x-2">
          { token ? <>
            <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="37" height="37" rx="18.5" fill="white" stroke="#F0AB83"/>
            <g opacity="0.3">
            <path d="M19.0002 20.4C20.0346 20.4 21.0265 19.9891 21.7579 19.2577C22.4893 18.5263 22.9002 17.5343 22.9002 16.5C22.9002 15.4656 22.4893 14.4737 21.7579 13.7423C21.0265 13.0109 20.0346 12.6 19.0002 12.6C17.9659 12.6 16.9739 13.0109 16.2425 13.7423C15.5111 14.4737 15.1002 15.4656 15.1002 16.5C15.1002 17.5343 15.5111 18.5263 16.2425 19.2577C16.9739 19.9891 17.9659 20.4 19.0002 20.4ZM10.5047 28.8409C10.384 29.1634 10.3707 29.5163 10.4667 29.8471C10.5628 30.1778 10.763 30.4687 11.0377 30.6765C13.3144 32.4458 16.1168 33.4043 19.0002 33.4C22.0032 33.4 24.7696 32.3808 26.9705 30.67C27.5295 30.2371 27.7557 29.4961 27.5009 28.837C26.8408 27.1184 25.6751 25.6404 24.1577 24.598C22.6403 23.5556 20.8424 22.9977 19.0015 22.9982C17.1605 22.9986 15.3629 23.5572 13.846 24.6003C12.329 25.6434 11.164 27.122 10.5047 28.8409Z" fill="#77808C"/>
            </g>
          </svg>
          </>
            : <>
              <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1.5" y="1.5" width="35" height="35" rx="17.5" fill="white" stroke="#F0AB83" strokeWidth="3" />
            <path d="M25.6667 13.1667H15.6667V16.5H14V11.5H27.3333V26.5H14V21.5H15.6667V24.8333H25.6667V13.1667Z" fill="#77808C" />
            <path d="M19.8951 23.125L18.7167 21.9467L20.8301 19.8333H10.6667V18.1667H20.8301L18.7167 16.0542L19.8951 14.875L24.0201 19L19.8951 23.125Z" fill="#BBC0C5" />
          </svg>
            </> }
          
          <span>{ token ? 'Dashboard' : 'Login' }</span>
        </button>

        {/* Free Trial Button */}
        <button onClick={logOut} className="bg-[#6ABA9B] text-white hover:bg-[#3baa80] transition-colors duration-300 rounded-full ps-1 pe-6 py-1 flex items-center space-x-2">
        { token ? <>
            <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="38" height="38" rx="19" fill="#94D8BE"/>
            <path d="M23.56 12.44L22.11 13.89C22.9912 14.4206 23.7203 15.1698 24.2266 16.0652C24.733 16.9605 24.9994 17.9714 25 19C25 20.5913 24.3679 22.1174 23.2426 23.2426C22.1174 24.3679 20.5913 25 19 25C17.4087 25 15.8826 24.3679 14.7574 23.2426C13.6321 22.1174 13 20.5913 13 19C13 16.83 14.16 14.94 15.88 13.88L14.44 12.44C13.3779 13.1728 12.5098 14.1528 11.9106 15.2955C11.3113 16.4383 10.9988 17.7096 11 19C11 21.1217 11.8429 23.1566 13.3431 24.6569C14.8434 26.1571 16.8783 27 19 27C21.1217 27 23.1566 26.1571 24.6569 24.6569C26.1571 23.1566 27 21.1217 27 19C27 16.28 25.64 13.88 23.56 12.44ZM20 10H18V20H20" fill="#FFF"/>
            </svg></>
            : <>
              <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1.5" y="1.5" width="35" height="35" rx="17.5" fill="white" stroke="#94D8BE" stroke-width="3" />
            <path d="M16 25C18.2091 25 20 23.2091 20 21C20 18.7909 18.2091 17 16 17C13.7909 17 12 18.7909 12 21C12 23.2091 13.7909 25 16 25Z" stroke="#77808C" stroke-width="2" />
            <path d="M19 18L22.5 14.5M22.5 14.5L24 13M22.5 14.5L25 17" stroke="#77808C" stroke-width="2" stroke-linecap="round" />
          </svg>
            </> }
            
          <span>{ token ? 'Logout' : 'Free Trial' }</span>
        </button>
      </div>

      {/* Mobile Navigation */}
      <div className="md:hidden flex items-center z-50">
        <button onClick={toggleNav} className="text-white">
          {/* Hamburger Icon */}
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.5 7.5H25.5V10.5H4.5V7.5ZM4.5 14.25H25.5V17.25H4.5V14.25ZM4.5 21H25.5V24H4.5V21Z" fill="white" />
          </svg>
        </button>
      </div>

      {/* Mobile Navigation Dropdown */}
      {isNavOpen && (
        <div className="bg-[#141e28] absolute top-16 left-0 w-full shadow-lg z-40 mt-4 rounded-none">
          <nav className="flex flex-col p-4">
            {navItems.map(({ id, link, text }) => (
              <a key={id} href={link} onClick={(event) => handleLinkClick(id, event)} className={`py-2 text-white ${activeLink === id ? 'font-bold' : ''}`}>
                {text}
              </a>
            )) }
            <a target='_blank' href="https://wa.me/18009809563?text=Talk2Agent" className={'py-2 text-white hover:text-white transition-colors duration-300'}>
                Contact Us
            </a>
          </nav>
          <div className="border-y border-[#FFFFFF1A] px-4 w-full"></div>
          <div className='px-4 pb-4'>
            <h1 className='text-[#B4BCC8] font-bold text-lg text-center mt-14'>How we are ?</h1>
            <p className='text-white font-normal text-center mt-6'><span className='text-[#DF8450] font-bold'>1Confirmed</span> is your go-to solution for seamless communication, offering an integrated WhatsApp Business Platform that enables businesses to send broadcast campaigns directly to their contacts. Our platform elevates your marketing efforts by making it easy to share updates, promotions, and other announcements efficiently.</p>
            <div className="justify-center space-x-3 py-7 flex items-center">
              <button onClick={logIn} className="bg-[#DF8450] text-white hover:bg-[#c96d3b] transition-colors duration-300 rounded-full ps-1 pe-6 py-1 flex items-center space-x-2">
                { token ? <>
                  <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0.5" y="0.5" width="37" height="37" rx="18.5" fill="white" stroke="#F0AB83"/>
                  <g opacity="0.3">
                  <path d="M19.0002 20.4C20.0346 20.4 21.0265 19.9891 21.7579 19.2577C22.4893 18.5263 22.9002 17.5343 22.9002 16.5C22.9002 15.4656 22.4893 14.4737 21.7579 13.7423C21.0265 13.0109 20.0346 12.6 19.0002 12.6C17.9659 12.6 16.9739 13.0109 16.2425 13.7423C15.5111 14.4737 15.1002 15.4656 15.1002 16.5C15.1002 17.5343 15.5111 18.5263 16.2425 19.2577C16.9739 19.9891 17.9659 20.4 19.0002 20.4ZM10.5047 28.8409C10.384 29.1634 10.3707 29.5163 10.4667 29.8471C10.5628 30.1778 10.763 30.4687 11.0377 30.6765C13.3144 32.4458 16.1168 33.4043 19.0002 33.4C22.0032 33.4 24.7696 32.3808 26.9705 30.67C27.5295 30.2371 27.7557 29.4961 27.5009 28.837C26.8408 27.1184 25.6751 25.6404 24.1577 24.598C22.6403 23.5556 20.8424 22.9977 19.0015 22.9982C17.1605 22.9986 15.3629 23.5572 13.846 24.6003C12.329 25.6434 11.164 27.122 10.5047 28.8409Z" fill="#77808C"/>
                  </g>
                </svg>
                </>
                  : <>
                    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="1.5" y="1.5" width="35" height="35" rx="17.5" fill="white" stroke="#F0AB83" strokeWidth="3" />
                  <path d="M25.6667 13.1667H15.6667V16.5H14V11.5H27.3333V26.5H14V21.5H15.6667V24.8333H25.6667V13.1667Z" fill="#77808C" />
                  <path d="M19.8951 23.125L18.7167 21.9467L20.8301 19.8333H10.6667V18.1667H20.8301L18.7167 16.0542L19.8951 14.875L24.0201 19L19.8951 23.125Z" fill="#BBC0C5" />
                </svg>
                  </> }
                
                <span>{ token ? 'Dashboard' : 'Login' }</span>
              </button>

              {/* Free Trial Button */}
              <button onClick={logOut} className="bg-[#6ABA9B] text-white hover:bg-[#3baa80] transition-colors duration-300 rounded-full ps-1 pe-6 py-1 flex items-center space-x-2">
              { token ? <>
                  <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="38" height="38" rx="19" fill="#94D8BE"/>
                  <path d="M23.56 12.44L22.11 13.89C22.9912 14.4206 23.7203 15.1698 24.2266 16.0652C24.733 16.9605 24.9994 17.9714 25 19C25 20.5913 24.3679 22.1174 23.2426 23.2426C22.1174 24.3679 20.5913 25 19 25C17.4087 25 15.8826 24.3679 14.7574 23.2426C13.6321 22.1174 13 20.5913 13 19C13 16.83 14.16 14.94 15.88 13.88L14.44 12.44C13.3779 13.1728 12.5098 14.1528 11.9106 15.2955C11.3113 16.4383 10.9988 17.7096 11 19C11 21.1217 11.8429 23.1566 13.3431 24.6569C14.8434 26.1571 16.8783 27 19 27C21.1217 27 23.1566 26.1571 24.6569 24.6569C26.1571 23.1566 27 21.1217 27 19C27 16.28 25.64 13.88 23.56 12.44ZM20 10H18V20H20" fill="#FFF"/>
                  </svg></>
                  : <>
                    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="1.5" y="1.5" width="35" height="35" rx="17.5" fill="white" stroke="#94D8BE" stroke-width="3" />
                  <path d="M16 25C18.2091 25 20 23.2091 20 21C20 18.7909 18.2091 17 16 17C13.7909 17 12 18.7909 12 21C12 23.2091 13.7909 25 16 25Z" stroke="#77808C" stroke-width="2" />
                  <path d="M19 18L22.5 14.5M22.5 14.5L24 13M22.5 14.5L25 17" stroke="#77808C" stroke-width="2" stroke-linecap="round" />
                </svg>
                  </> }
                  
                <span>{ token ? 'Logout' : 'Free Trial' }</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default ResponsiveAppBar;
